export default "__VITE_ASSET__6lz79Fzi__";